import { render, staticRenderFns } from "./GameBuddyList.vue?vue&type=template&id=5e8f44a1&scoped=true"
import script from "./GameBuddyList.vue?vue&type=script&lang=js"
export * from "./GameBuddyList.vue?vue&type=script&lang=js"
import style0 from "./GameBuddyList.vue?vue&type=style&index=0&id=5e8f44a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f44a1",
  null
  
)

export default component.exports